import { GET_LEDGER } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface Response {
    success: boolean;
    balance: number;
    total: number;
    ledger: LedgerObject[];
}

export interface LedgerObject {
    narrative: string;
    type: string;
    tx_type: string;
    amount: number;
    length: number;
    last_tx_date: string;
    transactions: Transaction[];
}

export interface Transaction {
    _id: string;
    _journal: string;
    account_path: string[];
    accounts: string;
    book: string;
    credit: number;
    datetime: string;
    debit: number;
    memo: string;
    timestamp: string;
    unique_key: string;
    transaction_id: string;
}

export default (startDate: string, endDate: string): Promise<Response> => {
    return fetchWithRefresh(GET_LEDGER(startDate, endDate)).then((res) => res.json());
};
